import { render, staticRenderFns } from "./TgStatusBtn.vue?vue&type=template&id=61c5913c"
import script from "./TgStatusBtn.vue?vue&type=script&lang=js"
export * from "./TgStatusBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports